import apiClient from '@app/config/axios.config'
import { Endpoint } from './adaptationLibrary.endpoints'

import {
  AdaptionLibraryResponse,
  AdaptationLibraryItem,
  AdaptationLibraryFilter,
} from '../utils/adaptationLibrary.types'

export const fetchAdaptationLibrary = async (
  pageNumber: number,
  pageSize: number,
  filter: AdaptationLibraryFilter,
): Promise<AdaptionLibraryResponse> => {
  const response = await apiClient.get(
    `${Endpoint.adaptationInterventions}?page_number=${pageNumber}&page_size=${pageSize}&search=${filter.search}&cost=${filter.cost.join(',')}&location=${filter.location.join(',')}&timeframe=${filter.timeframe.join(',')}&lead_time=${filter.lead_time.join(',')}&para_category=${filter.para_category.join(',')}&hazards_addressed=${filter.hazards_addressed.join(',')}&risk_management_type=${filter.risk_management_type.join(',')}`,
  )
  return response.data
}

export const fetchAdaptationLibraryItem = async (id: string): Promise<AdaptationLibraryItem> => {
  const response = await apiClient.get(`${Endpoint.adaptationInterventions}/${id}`)
  return response.data
}

export const fetchAdaptationLibraryFilters = async (): Promise<AdaptationLibraryFilter> => {
  const response = await apiClient.get(Endpoint.adaptationInterventionFilters)
  return response.data
}
